import {FileParams} from "../types/file.types";
import {FilesStatus} from "../types/files-status.types";

export const defaultFileParams: FileParams = {
  id: 0,
  filename: '',
  size: 0
}

export const defaultFilesStatus: FilesStatus = {
  recordCalendarId: 0
}
